const fallbackHubSpotPortalId = "247653320";
const fallbackHubSpotFormId = "1bad9b4c-a834-426b-9b49-4f2e97f46174";

const hubSpotPortalId =
  process.env.REACT_APP_HUBSPOT_PORTAL_ID || fallbackHubSpotPortalId;
const hubSpotFormId =
  process.env.REACT_APP_HUBSPOT_FORM_ID || fallbackHubSpotFormId;
const projectFieldName =
  process.env.REACT_APP_HUBSPOT_PROJECT_FIELD || "project_need";
const messageFieldName =
  process.env.REACT_APP_HUBSPOT_MESSAGE_FIELD || "message";

const hasHubSpotValue = (value) =>
  Boolean(value) && !value.includes("REACT_APP_");

export const isHubSpotConfigured =
  hasHubSpotValue(hubSpotPortalId) && hasHubSpotValue(hubSpotFormId);

const getCookie = (name) => {
  if (typeof document === "undefined") {
    return "";
  }

  const match = document.cookie.match(
    new RegExp(`(^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1")}=([^;]*)`)
  );

  return match ? decodeURIComponent(match[2]) : "";
};

export const submitHubSpotLead = async ({ email, projectNeed, message }) => {
  if (!isHubSpotConfigured) {
    return { skipped: true };
  }

  const fields = [
    { name: "email", value: email },
    { name: projectFieldName, value: projectNeed },
    { name: messageFieldName, value: message },
  ].filter((field) => field.value);

  const hutk = getCookie("hubspotutk");
  const context = {
    pageUri: window.location.href,
    pageName: document.title,
  };

  if (hutk) {
    context.hutk = hutk;
  }

  const response = await fetch(
    `https://api.hsforms.com/submissions/v3/integration/submit/${hubSpotPortalId}/${hubSpotFormId}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ fields, context }),
    }
  );

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || "HubSpot lead submission failed.");
  }

  return response.json();
};
